import React from "react";
import { ProfileNavbar } from "../../Components";
import ImageGallaryComponent from "./ImageGalery";

export const Galery = () => {
  return (
    <div>
      <ProfileNavbar />
      <ImageGallaryComponent />
    </div>
  );
};
